import { supabase } from "@/lib/supabaseClient";

export type PeriodWorkspaceBundle = Record<string, unknown>;

export async function getPeriodWorkspaceBundle(
  periodId: string
): Promise<PeriodWorkspaceBundle> {
  const { data, error } = await supabase
    .schema("payroll")
    .rpc("get_period_workspace_bundle", {
      p_period_id: periodId,
    });

  if (error) {
    throw error;
  }

  return (data ?? {}) as PeriodWorkspaceBundle;
}